import React from 'react';

const AdminAccount = () => {
  return <div></div>;
};

export default AdminAccount;
